import Button from '../../../components/base/Button';

export default function PricingSection() {
  const plans = [
    {
      title: '3 Months',
      subtitle: 'One-Time Payment',
      price: '£35',
      popular: false,
      features: [
        'Instant Activation',
        'Complete Device Setup Support',
        'App Configuration & Optimization',
        'Entertainment System Setup',
        'Technical Configuration Service',
        '4K / Ultra HD / HD Optimization',
        'Advanced Performance Tuning',
        'Compatible with all devices',
        'System Updates & Maintenance',
        'FREE Auto-Updating Support',
        '24/7 Technical Assistance',
        'Satisfied or Refunded'
      ]
    },
    {
      title: '6 Months',
      subtitle: 'One-Time Payment',
      price: '£60',
      popular: true,
      badge: 'Most Popular',
      features: [
        'Instant Activation',
        'Complete Device Setup Support',
        'App Configuration & Optimization',
        'Entertainment System Setup',
        'Technical Configuration Service',
        '4K / Ultra HD / HD Optimization',
        'Advanced Performance Tuning',
        'Compatible with all devices',
        'System Updates & Maintenance',
        'FREE Auto-Updating Support',
        '24/7 Technical Assistance',
        'Satisfied or Refunded'
      ]
    },
    {
      title: '12 Months',
      subtitle: 'One-Time Payment',
      price: '£80',
      popular: false,
      features: [
        'Instant Activation',
        'Complete Device Setup Support',
        'App Configuration & Optimization',
        'Entertainment System Setup',
        'Technical Configuration Service',
        '4K / Ultra HD / HD Optimization',
        'Advanced Performance Tuning',
        'Compatible with all devices',
        'System Updates & Maintenance',
        'FREE Auto-Updating Support',
        '24/7 Technical Assistance',
        'Satisfied or Refunded'
      ]
    }
  ];

  return (
    <section id="pricing" className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Affordable plans for any situation
          </h2>
          <p className="text-lg text-gray-300 max-w-3xl mx-auto">
            Experience professional digital media support services, accessible on every device.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {plans.map((plan, index) => (
            <div key={index} className={`relative bg-white text-gray-900 rounded-2xl p-8 ${plan.popular ? 'ring-4 ring-orange-500 transform scale-105' : ''}`}>
              {plan.badge && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-gradient-to-r from-orange-500 to-red-500 text-white px-4 py-2 rounded-full text-sm font-semibold">
                  {plan.badge}
                </div>
              )}
              
              <div className="text-center mb-8">
                <h3 className="text-2xl font-bold mb-2">{plan.title}</h3>
                <p className="text-gray-600 mb-4">{plan.subtitle}</p>
                <div className="mb-4">
                  <span className="text-4xl font-bold">{plan.price}</span>
                  {plan.originalPrice && (
                    <span className="text-lg text-gray-500 line-through ml-2">{plan.originalPrice}</span>
                  )}
                </div>
              </div>

              <ul className="space-y-3 mb-8">
                {plan.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center">
                    <i className="ri-check-line text-green-500 mr-3"></i>
                    <span className="text-sm">{feature}</span>
                  </li>
                ))}
              </ul>

              <Button 
                variant={plan.popular ? 'primary' : 'outline'} 
                className="w-full"
                href="https://wa.me/qr/QOVGSHQTONIKJ1"
              >
                GET PREMIUM
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
